import { createGlobalStyle } from "styled-components";
import { color } from "./globals";

const GlobalThemeStyles = createGlobalStyle<{ isMotorRenewal?: boolean }>`
  :root ${(props) => props.theme.themeConfig}

  ${(props) =>
    props.isMotorRenewal
      ? `
    :root {
      --ui-form-selection-background-color: ${color.icthBlue01};
      --ui-form-selection-text-color: #ffffff;
    }

    ::selection,
    *::selection,
    img::selection {
      background-color: ${color.icthBlue01};
      color: #ffffff;
    }
    ::-moz-selection,
    *::-moz-selection,
    img::-moz-selection {
      background-color: ${color.icthBlue01};
      color: #ffffff;
    }
  `
      : `
    ::selection {
      background: var(--ui-form-selection-background-color,#1890ff);
      color: var(--ui-form-selection-text-color,#fff);
    }
  `}
`;

export default GlobalThemeStyles;
